import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import {
  GET_MEMBERSHIPS_BIN_MONTHLY_STATS,
  GET_MEMBERSHIPS_BIN_MONTHLY_STATS_ERROR,
  GET_MEMBERSHIPS_BIN_MONTHLY_STATS_SUCCESS,
} from '../../actions.js';

function* getMembershipsBinMonthlyStats({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/v1/membership-bin-monthly-stats`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_MEMBERSHIPS_BIN_MONTHLY_STATS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_MEMBERSHIPS_BIN_MONTHLY_STATS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_MEMBERSHIPS_BIN_MONTHLY_STATS_ERROR, payload: error });
  }
}

export function* watchGetMembershipsBinMonthlyStats() {
  yield takeEvery(GET_MEMBERSHIPS_BIN_MONTHLY_STATS, getMembershipsBinMonthlyStats);
}

function* getMembershipsBinMonthlyStatsSaga() {
  yield all([fork(watchGetMembershipsBinMonthlyStats)]);
}

export default getMembershipsBinMonthlyStatsSaga;
